import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import TspSupplierReportDetailsData from './TspSupplierReportDetailsData';
import useFetch from '../../../hooks/useFetch';


export default function TspSupplierReportDetails() {
  const { state } = useLocation();

  const { data, isLoading } = useFetch(`tsp/getAllTspDetails/?id=${state}`);

  if (isLoading) {
    return (
      <>
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
          </div>
        </main>
      </>
    )
  }

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">
            <Link to="/tspsupplierreport" >
              <i className="fa-solid fa-arrow-left"></i>
            </Link>{' '}
            TSP Supplier Report Details
          </h1>
        </div>
        <div>
          <h4>
            <small>Seller: {data.seller.name}</small>
          </h4>
          <h4>
            <small>Year: {data.year}</small>
          </h4>
        </div>
        <div class="table-responsive">
          <table className="table table-bordered table-hover table-sm">
            <thead>
              <tr>
                <th>Question</th>
                <th>Assessed</th>
                <th>Planned	Comments</th>
                <th>Opportunity</th>
                <th>Yes</th>
                <th>Mostly yes</th>
                <th>Mostly no</th>
                <th>No</th>
                <th>Not applicable</th>
                <th>Nb respondents</th>
                <th>Environmental</th>
                <th>Ops/maintenance</th>
                <th>Financial</th>
                <th>Implementation ease</th>
                <th>AVERAGE VALUE</th>
              </tr>
            </thead>
            <tbody>
              <TspSupplierReportDetailsData data={data.data} id={data.id} />
            </tbody>
          </table>
        </div>
      </main>
    </>
  )
}